{
  "title": "Returns & Refunds",
  "request_title": "Return request",
  "my_returns": "My returns",
  "no_returns": "No returns",
  "no_returns_description": "You have not made any return requests.",
  "policy": {
    "title": "Return policy",
    "window": "You have {{days}} days after delivery to request a return.",
    "deadline": "Return deadline: {{date}}",
    "photos_required": "Photos are required for this request.",
    "auto_approve_notice": "Returns under {{amount}} FCFA are automatically approved."
  },
  "reasons": {
    "DEFECTIVE": "Defective product",
    "WRONG_ITEM": "Wrong item received",
    "NOT_AS_DESCRIBED": "Not as described",
    "CHANGED_MIND": "Changed my mind",
    "EXPIRED": "Expired product",
    "OTHER": "Other"
  },
  "status": {
    "REQUESTED": "Requested",
    "APPROVED": "Approved",
    "PICKUP_SCHEDULED": "Pickup scheduled",
    "RECEIVED": "Received",
    "REFUND_PROCESSING": "Refund processing",
    "REFUND_COMPLETED": "Refunded",
    "REJECTED": "Rejected"
  },
  "refund_methods": {
    "ORIGINAL_PAYMENT": "Original payment method",
    "WAVE": "Wave",
    "ORANGE_MONEY": "Orange Money",
    "STORE_CREDIT": "Store credit"
  },
  "form": {
    "step_items": "Select items",
    "step_reason": "Return reason",
    "step_details": "Details & photos",
    "step_review": "Review",
    "select_items": "Select items to return",
    "quantity": "Quantity",
    "reason_label": "Reason for return",
    "reason_placeholder": "Select a reason",
    "description_label": "Problem description",
    "description_placeholder": "Describe the issue with your order…",
    "photos_label": "Photos (optional)",
    "photos_hint": "Add photos to help process your request.",
    "review_order": "Order",
    "review_items": "Items to return",
    "review_reason": "Reason",
    "review_description": "Description",
    "review_refund_estimate": "Estimated refund",
    "submit": "Submit request",
    "submitting": "Submitting…",
    "cancel": "Cancel",
    "next": "Next",
    "previous": "Previous",
    "success_title": "Request submitted successfully",
    "success_message": "Your return request has been submitted. Our team will review it within 48 hours.",
    "success_ref": "Return ref: {{id}}",
    "error_no_items": "Please select at least one item.",
    "error_no_reason": "Please select a reason.",
    "error_no_description": "Please describe the problem.",
    "error_generic": "An error occurred. Please try again."
  },
  "card": {
    "order_ref": "Order {{ref}}",
    "created_on": "Requested on {{date}}",
    "resolved_on": "Resolved on {{date}}",
    "refund_amount": "Refund amount",
    "refund_method": "Refund method",
    "rejection_reason": "Rejection reason",
    "items_count": "{{count}} item",
    "items_count_plural": "{{count}} items",
    "tracking": "Tracking"
  },
  "filter": {
    "all": "All",
    "active": "Active",
    "completed": "Completed"
  },
  "loading": "Loading returns…",
  "error_loading": "Unable to load your returns."
}
